
export default {
  props: {
    product: { type: Object, default: () => {} },
  },

  computed: {
    allPdpVideos() {
      const videoSrc = this.product?.external_video;
      return (videoSrc || []).map(url => ({ src: url }));
    },
  },
};
